import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {PlatformLocation} from '@angular/common';


@Component({
    selector: 'remove-all-vehicle',
    templateUrl: './remove-all.component.html',
    styleUrls: ['remove-all.component.scss']
})

export class RemoveAllComponent implements OnInit {
    @Input() disableRemoveAll;
    @Output() removeConfirmed = new EventEmitter();
    modalRef: BsModalRef;

    constructor( private modalDialogService: BsModalService, private location: PlatformLocation) {
        location.onPopState( () => {
            if (this.modalRef) {
                this.modalRef.hide()
            }
        });
    }

    ngOnInit(): void {
    }

    openRemoveModal(template) {
        this.modalRef = this.modalDialogService.show(template, {class: 'modal-md'})
    }

    confirmRemove() {
        this.removeConfirmed.emit(true);
        this.modalRef.hide();
    }

    cancelRemove() {
        this.modalRef.hide();
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/components-v1/remove-all-v1/remove-all.component.ts